/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'

export interface SliderProps extends React.ComponentProps<'div'> {
  value?: number
  defaultValue?: number
  // eslint-disable-next-line no-unused-vars
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  min?: number
  max?: number
}

export const CustomSlider = React.forwardRef<HTMLDivElement, SliderProps>(
  ({ value = 0, defaultValue, onChange, min = 0, max = 200, ...rest }, ref) => {
    const [innerValue, setInnerValue] = React.useState(defaultValue || 0)

    React.useMemo(() => {
      if (defaultValue) setInnerValue(defaultValue)
    }, [defaultValue])

    const domId = 'Slider'

    return (
      <div
        {...rest}
        ref={ref}
        className="relative w-full min-w-[200px] text-night h-2"
      >
        <label
          htmlFor={domId}
          className="absolute inset-0 z-10 h-full bg-current rounded-l-full pointer-events-none"
          style={{
            width: `${
              (Number(value || innerValue) / Number(max || 100)) * 100
            }%`,
          }}
        />
        <input
          id={domId}
          type="range"
          max={max}
          min={min}
          className="w-full absolute inset-0 bg-transparent cursor-pointer focus:outline-none focus:outline-0 appearance-none [-webkit-appearance:none] [&::-webkit-slider-runnable-track]:h-full [&::-moz-range-track]:h-full [&::-webkit-slider-runnable-track]:rounded-full [&::-moz-range-track]:rounded-full [&::-webkit-slider-runnable-track]:bg-blue-gray-100 [&::-moz-range-track]:bg-blue-gray-100 [&::-moz-range-thumb]:appearance-none [&::-moz-range-thumb]:[-webkit-appearance:none] [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:[-webkit-appearance:none] [&::-moz-range-thumb]:rounded-full [&::-webkit-slider-thumb]:rounded-full [&::-moz-range-thumb]:border-0 [&::-webkit-slider-thumb]:border-0 [&::-moz-range-thumb]:ring-2 [&::-webkit-slider-thumb]:ring-2 [&::-moz-range-thumb]:ring-current [&::-webkit-slider-thumb]:ring-current [&::-moz-range-thumb]:bg-white [&::-webkit-slider-thumb]:bg-white [&::-moz-range-thumb]:relative [&::-webkit-slider-thumb]:relative [&::-moz-range-thumb]:z-20 [&::-webkit-slider-thumb]:z-20 [&::-moz-range-thumb]:w-3.5 [&::-webkit-slider-thumb]:w-3.5 [&::-moz-range-thumb]:h-3.5 [&::-webkit-slider-thumb]:h-3.5 [&::-moz-range-thumb]:-mt-[3px] [&::-webkit-slider-thumb]:-mt-[3px]"
          value={value}
          defaultValue={defaultValue}
          onChange={(e) =>
            onChange ? onChange(e) : setInnerValue(Number(e.target.value))
          }
        />
      </div>
    )
  },
)

export default CustomSlider
